import {
  Component,
  computed,
  inject,
  input,
  OnDestroy,
  OnInit,
  signal,
} from "@angular/core";
import { NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { NgClass } from "@angular/common";
import { LayoutService } from "../../../layout.service";
import { BaseComponent } from '@core/base/base-component';
import { AppSvgIconComponent } from '@vallift/ngl';
import { TooltipDirective } from '@shared/components/tooltip/tooltip.directive';

@Component({
  selector: 'app-sidebar-menu',
  standalone: true,
  imports: [
    AppSvgIconComponent,
    NgClass,
    TooltipDirective,
    TooltipDirective,
    TooltipDirective,
    TooltipDirective,
  ],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss',
})
export class SidebarMenuComponent extends BaseComponent implements OnInit, OnDestroy {
  layoutService = inject(LayoutService);

  activeRoute = signal(this.router.url);
  private routeSubscription!: Subscription;
  menuItem = input.required<SideMenuItem>();

  isActive = computed(() => {
    const active = this.activeRoute();
    const link = this.menuItem().link;
    return active === link || active.startsWith(`${link}/`);
  });

  ngOnInit(): void {
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.activeRoute.set(this.router.url);
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  onMenuClicked(menuItem: SideMenuItem) {
    if (menuItem.link) {
      this.router.navigate([menuItem.link]);
    }

    if (menuItem.externalLink) {
      window.open(menuItem.externalLink, '_blank');
    }

    const subMenus = menuItem.submenus ?? [];
    if (subMenus.length > 0) {
      this.menuItem().expanded = !this.menuItem().expanded;
    }
  }
}

export interface SideMenuGroup {
  label: string | null;
  items: SideMenuItem[];
}

export interface SideMenuItem {
  iconPath: string;
  link: string;
  externalLink?: string;
  label: string;
  isEnabled: boolean;
  expanded?: boolean;
  submenus?: SideMenuItem[];
}
